// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root__3eDbp","label":"Section_label__1Al5_","contentWrap":"Section_contentWrap__HNN6R","footer":"Section_footer__1IUyv","footerInner":"Section_footerInner__1moqN"};